import { useTranslation } from "../../../components/Translation";

export default function ContactMap() {
  const { t } = useTranslation();

  return (
    <div className="w-full h-72 overflow-hidden relative">
      <iframe
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3723.5961159964604!2d-89.64597792496795!3d21.048840480605513!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8f5675004df3a963%3A0x3613d39756ace232!2sLaboratorio%20de%20rob%C3%B3tica%20e%20industria%204.0!5e0!3m2!1ses-419!2smx!4v1729760398270!5m2!1ses-419!2smx"
        width="100%"
        height="100%"
        style={{ border: 0 }}
        allowFullScreen
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
        title={t("contact.map_title")}
      />
      {/* Location badge overlay */}
      <div className="absolute top-4 left-4 bg-white rounded-lg shadow px-4 py-2 text-mini font-semibold text-azul-uady flex items-center gap-2">
        <span>📍</span> {t("contact.map_badge")}
      </div>
    </div>
  );
}